import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import ShareForm from '../../components/share-form';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

const ShareCommentModal = ({ closeModal, categorySlug, postSlug, t }) =>
  <Modal onClose={closeModal}>
    {/*<ShareForm title={TITLE} path={`/${categorySlug}/${postSlug}#${commentId}`}/>*/}
    <ShareForm title={t('share-comment-modal.share-comment')} path={`/${categorySlug}/${postSlug}`}/>
  </Modal>;

ShareCommentModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  categorySlug: PropTypes.string.isRequired,
  postSlug: PropTypes.string.isRequired,
  commentId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  closeModal,
};

export default connect(undefined, mapDispatchToProps)(withTranslate(ShareCommentModal));



// WEBPACK FOOTER //
// ./app/containers/share-comment-modal/share-comment-modal.js